import React from 'react';
import { TabPanel as AriaTabPanel, type Key } from 'react-aria-components';
import styles from './Tabs.module.css';

export interface TabPanelProps {
  /**
   * Unique identifier that matches a Tab id
   */
  id: Key;
  /**
   * Panel content to display when tab is selected
   */
  children: React.ReactNode;
  /**
   * Additional CSS class names
   * @ignore
   */
  className?: string;
  /**
   * Test ID for the component, used for testing purposes
   */
  'data-testid'?: string;
}
export const TabPanel: React.FC<TabPanelProps> = ({
  id,
  children,
  className,
  'data-testid': dataTestId,
}) => {
  const combinedClassName = className
    ? `${styles.tabs__panel} ${className}`
    : styles.tabs__panel;

  return (
    <AriaTabPanel
      id={String(id)}
      className={combinedClassName}
      data-testid={dataTestId}
    >
      {children}
    </AriaTabPanel>
  );
};

export default TabPanel;
